import { trimInput } from "@/composables/trimInput";

const getDefaultState = () => {
  return {
    listaIstituti: [],
    currentPageIstituti: 1,
    totalElementsIstituti: 0,
    loadingIstituti: true,
    statusIstituti: true,
    errorIstituti: false,
    campiLockedIstituti: "",
    comandiLockedIstituti: "",
    rowsToSkipIstituti: 0,
    fetchRowsIstituti: 25,
    sortColumnIstituti: "istituto",
    sortOrderIstituti: "asc",
    codiceScuolaFilterIstituti: null,
    denominazioneFilterIstituti: null,
    idProvinciaIstitutiFilter: null,
  };
};
const state = getDefaultState();

const getters = {
  listaIstituti: (state) => state.listaIstituti,
  currentPageIstituti: (state) => state.currentPageIstituti,
  rowsToSkipIstituti: (state) => state.rowsToSkipIstituti,
  fetchRowsIstituti: (state) => state.fetchRowsIstituti,
  sortColumnIstituti: (state) => state.sortColumnIstituti,
  sortOrderIstituti: (state) => state.sortOrderIstituti,
  codiceScuolaFilterIstituti: (state) => state.codiceScuolaFilterIstituti,
  denominazioneFilterIstituti: (state) => state.denominazioneFilterIstituti,
  idProvinciaIstitutiFilter: (state) => state.idProvinciaIstitutiFilter,
  respIstituti: (state) => ({
    status: state.statusIstituti,
    loaded: !state.loadingIstituti,
    record: state.totalElementsIstituti,
  }),
};

const mutations = {
  setListaIstituti: (state, value) => {
    state.listaIstituti = value;
  },
  setFetchRowsIstituti: (state, value) => {
    state.currentPageIstituti = 1;
    state.fetchRowsIstituti = value;
  },
  setPageIstituti: (state, value) => {
    state.currentPageIstituti = value;
    state.rowsToSkipIstituti = parseInt(
      (state.currentPageIstituti - 1) * state.fetchRowsIstituti
    );
  },
  setRowsToSkipIstituti: (state) => {
    state.currentPageIstituti = 1;
    state.rowsToSkipIstituti = 0;
  },

  setSortColumnIstituti: (state, value) => {
    state.currentPageIstituti = 1;
    state.sortColumnIstituti = value;
  },
  setSortOrderIstituti: (state, value) => {
    state.currentPageIstituti = 1;
    state.sortOrderIstituti = value;
  },
  setCodiceScuolaFilterIstituti: (state, value) => {
    state.codiceScuolaFilterIstituti = value;
  },
  setDenominazioneFilterIstituti: (state, value) => {
    state.denominazioneFilterIstituti = trimInput(value);
  },
  idProvinciaIstitutiFilter: (state, value) => {
    state.idProvinciaIstitutiFilter = value;
  },
  setRespIstituti: (state, value) => {
    if (!value) {
      state.errorIstituti = true;
      state.loadingIstituti = false;
      return;
    }
    state.totalElementsIstituti = value?.data?.record;
    state.statusIstituti = value?.status;
    state.loadingIstituti = false;
  },
  resetIstitutiFilters: (state) => {
    state.currentPageIstituti = 1;
    state.codiceScuolaFilterIstituti = null;
    state.denominazioneFilterIstituti = null;
    state.idProvinciaIstitutiFilter = null;
  },
  loadIstituti: (state) => {
    state.loadingIstituti = true;
  },
};

export default {
  state,
  getters,
  mutations,
};
